module.exports = __webpack_public_path__ + "media/images/icons/brands/bootstrap-b4b098565120c6603516ba12ccf9b7ea.svg";